import { appAssetsCdnUrl } from '~/constants/environment';
import type { TopPickTile } from '~/contracts/dealership';
import encodeBase64 from '~/utilities/encodeBase64';

const topPicks: TopPickTile[] = [
  {
    name: 'Jeep Wrangler',
    image: `${appAssetsCdnUrl}/images/dealership/cdjr/jeep-wrangler.jpg`,
    blurb:
      'Iconic off-road performance with rugged style and open-air freedom.',
    cvnaId: encodeBase64(
      JSON.stringify({
        filters: {
          makes: [{ name: 'Jeep', parentModels: [{ name: 'Wrangler' }] }]
        }
      })
    )
  },
  {
    name: 'RAM 1500',
    image: `${appAssetsCdnUrl}/images/dealership/cdjr/ram-1500.jpg`,
    blurb: 'Heavy-duty strength, advanced towing power and bold truck design.',
    cvnaId: encodeBase64(
      JSON.stringify({
        filters: {
          makes: [{ name: 'Ram', parentModels: [{ name: '1500' }] }]
        }
      })
    )
  },
  {
    name: 'Chrysler Pacifica',
    image: `${appAssetsCdnUrl}/images/dealership/cdjr/chrysler-pacifica.jpg`,
    blurb:
      'Smart family versatility with sleek design, premium comfort and modern tech.',
    cvnaId: encodeBase64(
      JSON.stringify({
        filters: {
          makes: [{ name: 'Chrysler', parentModels: [{ name: 'Pacifica' }] }]
        }
      })
    )
  },
  {
    name: 'Dodge Charger',
    image: `${appAssetsCdnUrl}/images/dealership/cdjr/dodge-charger.jpg`,
    blurb:
      'Muscle car performance meets aggressive design and modern features.',
    cvnaId: encodeBase64(
      JSON.stringify({
        filters: {
          makes: [{ name: 'Dodge', parentModels: [{ name: 'Charger' }] }]
        }
      })
    )
  }
];

export default topPicks;
